export default "__VITE_PUBLIC_ASSET__43e4f87f__"